import type { RecordError } from '@drycut/graphql';

import { FormHelpText, InfoButton, Para, Stack } from '@drycut/ui-components';
import { ExclamationTriangleIcon } from '@heroicons/react/20/solid';

type Props = {
  error: RecordError;
};

export default function BookingError({ error }: Props): React.ReactElement {
  return (
    <FormHelpText error={true}>
      <Stack as="span" direction="row" gap={1} className="justify-center">
        Could not create booking
        <InfoButton
          iconClasses="text-red-400 w-5 h-5"
          title={
            <Stack direction="row" gap={2}>
              <ExclamationTriangleIcon className="w-5 h-5" />
              <Para as="span" weight="bold">
                Error
              </Para>
            </Stack>
          }
          text={
            <Para as="span" size="xs" className="font-mono">
              {error.message}
            </Para>
          }
        />
      </Stack>
    </FormHelpText>
  );
}
